import { useMemo } from "react";

import { firebase } from "astrid-firebase";
import getArticlesQuery from "astrid-firestore/src/api/articles/getArticlesQuery";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import sortArticles from "../utils/sortArticles";

export default function useArticles(options) {
	const [articles, loading, error] = useCollectionData(getArticlesQuery(firebase, options));

	const sortedArticles = useMemo(() => sortArticles(articles), [articles]);

	return [sortedArticles, loading, error];
}
